export const mapDataForRevenueDistributionByChannel = (data: {
  [key: string]: string;
}) =>
  Object.entries(data).reduce((acc, [key, value]) => {
    const [channel, period] = key.split("_");

    if (!acc[period]) {
      acc[period] = {};
    }
    acc[period] = {
      ...acc[period],
      [channel]: Number(value),
    };
    return acc;
  }, {} as Record<string, { [key: string]: number }>);
